// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"673":"d0c47037","707":"24ff95d3","2007":"24ff95d3","4041":"d0c47037","5947":"f5e6f42e","6870":"ba9c39e0","7812":"24ff95d3","9541":"24ff95d3"}[chunkId] + ".chunk.css";
};